import { render, staticRenderFns } from "./aab-vie-doc-client.vue?vue&type=template&id=0f591204&"
import script from "./aab-vie-doc-client.vue?vue&type=script&lang=js&"
export * from "./aab-vie-doc-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports